export default __webpack_public_path__ + "static/media/associate.f7cefe1d.png";